import React from 'react';
import './App.scss';
import Dashboard from './Pages/Dashboard';
import Sidebar from './Components/Sidebar';
import Layout from './Layout';
import { ToastContainer } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';
import Loader from './Components/Loader';
import { useSelector } from 'react-redux';
import Storelist from './Store/Actions';
import { useEffect } from 'react';
import "react-tooltip/dist/react-tooltip.css";
function App() {
  const {PageStore} = Storelist()

  
  return (
    <div className='main-container jbc-light'>
      {/* <Dashboard /> */}
      {/* <Sidebar /> */}
      <Layout />
     {PageStore?.is_loader && <Loader />}
      <ToastContainer 
      position="top-right"
      autoClose={800}
      hideProgressBar={false}
      pauseOnHover={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      limit={1}
      pauseOnFocusLoss={false}
      
      theme="light"
      />
    </div>
  );
}
export default App;
